import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import LoaderGif from '../../icons/LoaderGif.gif';

function LoadingComponent({ isLoading }) {
    return isLoading ? (
        <div className="Loader h-100">
            <img src={LoaderGif} alt="" className="Loader"></img>
        </div>
    ) : null;
}

LoadingComponent.propTypes = {
    isLoading: PropTypes.bool,
};

LoadingComponent.defaultProps = {
    isLoading: false,
};

export default LoadingComponent;
